import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import type { EndUsePhotoGroup, EndUseRecord, Reservation } from '../services/api';
import EndUseRecordForm from './EndUseRecordForm';
import EndUseRecordView from './EndUseRecordView';
import { buildEndUsePayload } from '../utils/endUseRecord';

export type EndUseModalMode = 'submit' | 'view';

interface EndUseRecordModalProps {
  show: boolean;
  mode: EndUseModalMode;
  reservation: Reservation | null;
  photoGroups: EndUsePhotoGroup[];
  onHide: () => void;
  onSubmit: (payload: ReturnType<typeof buildEndUsePayload>) => Promise<void>;
}

const EndUseRecordModal: React.FC<EndUseRecordModalProps> = ({
  show,
  mode,
  reservation,
  photoGroups,
  onHide,
  onSubmit
}) => {
  const bookerName =
    reservation && typeof reservation.userId === 'object'
      ? reservation.userId.name || reservation.userId.username
      : undefined;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === 'view' ? '结束使用记录' : '提交结束使用状态'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {mode === 'view' && reservation?.endUseRecord ? (
          <EndUseRecordView record={reservation.endUseRecord} bookerName={bookerName} />
        ) : (
          <>
            <p className="text-muted small">
              请按仪器要求上传各组照片并填写使用后状态说明，便于负责人了解设备情况。
            </p>
            <EndUseRecordForm
              photoGroups={photoGroups}
              initialRecord={reservation?.endUseRecord}
              onSubmit={async (payload) => {
                await onSubmit(payload);
                onHide();
              }}
              submitLabel={mode === 'submit' ? '保存结束使用记录' : '提交'}
            />
          </>
        )}
      </Modal.Body>
      {mode === 'view' && (
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            关闭
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default EndUseRecordModal;
